export default __webpack_public_path__ + "static/media/image.64828fa8.png";